import { createFileRoute } from '@tanstack/react-router';
import { useTranslations } from '@/i18n/translations';
import { AuthLayout } from '@/components/auth/AuthLayout';
import { PasswordResetForm } from '@/components/auth/PasswordResetForm';
import { returnPathSearchParam } from '@/lib/return-path';
import { redirectIfSignedIn } from '@/lib/use-session';

type PasswordResetSearch = {
  // The page the visitor was signing in to reach; kept through the reset so
  // they still land there.
  next?: string;
};

export const Route = createFileRoute('/auth/password-reset')({
  validateSearch: (search: Record<string, unknown>): PasswordResetSearch => {
    const next = returnPathSearchParam.parse(search['next']);
    return next !== undefined ? { next } : {};
  },
  beforeLoad: ({ context, search }) => redirectIfSignedIn(context, search.next),
  component: PasswordResetPage,
});

function PasswordResetPage() {
  const t = useTranslations('Auth');
  const { next } = Route.useSearch();
  return (
    <AuthLayout
      kicker={t('passwordReset.kicker')}
      headline={t('passwordReset.headline')}
    >
      <PasswordResetForm {...(next !== undefined ? { next } : {})} />
    </AuthLayout>
  );
}
